import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/subscription/billing` — kept as a deep link (old bookmarks, the payment-return pages' "See
 * billing history"). Billing history is now a dialog over Manage plan (owner C6, COMPARE-ac §11),
 * so this route only opens it there; Manage plan sends a Free member on to the plans with the
 * same dialog.
 */
export const Route = createFileRoute('/_app/subscription/billing')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/subscription/manage', search: { billing: true }, replace: true })
  },
})
